import { useState, useRef, useEffect } from 'react';
import ListComponent from '@/pcomponents/common/crud/list/list/list_component';
import my_axios, { get_axios_data } from "@/pcomponents/common/axios";
import strFunc from '@/lib/lyg/string';
import DateFunc from '@/lib/lyg/date_func';
import { useSelector, useDispatch } from 'react-redux';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import FindMainUserPopup from "@/pages/main/main_user/user/popup/find";
import getXcolumnJson from "./xcolumn/list";
import SearchArea from "./area/search";

function ShopManagerListArea(props: any) {
  let myProps = {
    ...props
  };
  let user = useSelector((state: any) => state.user);
  const xColumnArr = getXcolumnJson();
  const ListComponentRef = useRef<any>(null);
  const listOptRef = useRef<any>({});

  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    select_seq: "",
    s_addon_main_user: "1",
    is_paging: "",
  });
  listOptRef.current = listOpt;
  const [infoArr, setInfoArr] = useState<any>([]);
  const [countInfo, setCountInfo] = useState({ "tot": 0 });

  const default_popup_data = {
    isOpen: false,
    sort: "find_main_user",
    listOpt: {},
    title: "팝업",
    width: "100%",
    height: "90%",
  };
  const [popupData, setPopupData] = useState({ ...default_popup_data });

  useEffect(() => {
    list({});
  }, [user]);

  const list = (inOptObj: any) => {
    let tmp_list_opt = {
      ...listOpt,
      ...inOptObj
    };
    setListOpt(tmp_list_opt);

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_manager/list',
      tmp_list_opt, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          setInfoArr(response.data["data"]["info_arr"]);
          // setCountInfo(response.data["data"]["count_info"]);
          if (ListComponentRef.current) {
            ListComponentRef.current.setInfoArr(response.data["data"]["info_arr"]);
            setSelectbySelectedSeq({
              select_seq: tmp_list_opt.select_seq,
              info_arr: response.data["data"]["info_arr"],
            });
          }
        } else {

        }
      });
  };

  const setSelectbySelectedSeq = (inData: any) => {
    let opt_obj = {
      select_seq: "",
      info_arr: infoArr,
      ...inData
    };
    if (opt_obj.select_seq != "") {
      setTimeout(() => {
        if (ListComponentRef.current) {
          let active_row_arr: any = [];
          for (let i = 0; i < opt_obj.info_arr.length; i++) {
            let info = opt_obj.info_arr[i];
            if (info.row_pri_val == opt_obj.select_seq) {
              active_row_arr.push(true);
            } else {
              active_row_arr.push(false);
            }
          }
          ListComponentRef.current.set_active_row_arr(active_row_arr);
        }
      }, 100);
    }
  };

  const goDelete = (inData: any) => {
    let pre_selected_rows = ListComponentRef.current.getSelectedRows();
    let opt_obj = {
      selected_rows: pre_selected_rows,
      ...inData
    };
    let selected_rows = opt_obj.selected_rows;
    if (selected_rows.length === 0) {
      alert("선택없음.");
      return false;
    }
    if (!confirm("삭제하시겠습니까?")) {
      return false;
    }
    let del_form_data = {
      "data_arr": selected_rows
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_manager/delete', del_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const open_find_manager_popup = (inData: any) => {
    let opt_obj = {
      ...inData
    };

    let tmp_s_except_user_seq: any = [];
    for (let i = 0; i < infoArr.length; i++) {
      let info = infoArr[i];
      tmp_s_except_user_seq.push(info.a_main_user_seq);
    }
    let find_list_opt: any = {
      s_except_user_seq: tmp_s_except_user_seq
    };
    setPopupData({
      ...default_popup_data,
      isOpen: true,
      sort: "find_main_user",
      title: "관리자찾기",
      width: "80%",
      listOpt: find_list_opt,
    });
  };

  const callback_find_manager_data = (inData: any) => {
    let opt_obj = {
      ...inData
    };
    if (opt_obj["info_arr"].length == 0) {
      alert("선택된 관리자가 없습니다.");
      return false;
    }
    let add_manager_arr: any = [];
    for (let i = 0; i < opt_obj["info_arr"].length; i++) {
      let add_manager_row: any = {
        a_main_user_seq: opt_obj["info_arr"][i].a_seq,
        a_user_name: opt_obj["info_arr"][i].a_user_name,
        a_is_order_push: "",
        a_is_order_sms: "",
      };
      add_manager_arr.push(add_manager_row);
    };

    if (!confirm("선택한 관리자를 추가하시겠습니까?")) {
      return false;
    }

    let add_form_data = {
      data_arr: add_manager_arr,
      is_default_val: "1"
    };

    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_manager/write', add_form_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({});
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const update_manager_by_ajax = (inData: any) => {
    let opt_obj = {
      data_arr: [],
      select_seq: "",
      ...inData
    };
    let form_json_data = {
      data_arr: opt_obj.data_arr
    };
    my_axios.post(process.env.REACT_APP_API_URL + '/api/main/shop/shop_manager/write', form_json_data, get_axios_data())
      .then((response) => {
        if (response.data["result"] === "true") {
          list({ select_seq: opt_obj.select_seq });
        } else {
          alert(response.data["msg"]);
        }
      });
  };

  const rowOnClick = (rowData: any, idx: number, e: any, key: string) => {

  };

  const customCellRenderer = (params: any) => {
    /*
    {
      "rowData":rowData,
      "idx":idx,
      "key":key,
      "value":row_val,
      "origin_val":origin_val,
    }
    */
    let render_val = params.value;
    if (params.key === "a_user_name") {
      if (params.rowData["main_user_info"]) {
        render_val = params.rowData["main_user_info"]["a_user_name"];
      }
    } else if (params.key === "a_is_order_push" || params.key === "a_is_order_sms") {
      let tmp_is_checked = params.value == "1" ? true : false;
      render_val = (
        <input type="checkbox" checked={tmp_is_checked}
          style={{ width: 20, height: 20 }}
          onChange={(e) => {
            let change_val = e.target.checked ? "1" : "0";
            let update_data_arr: any = [];
            let update_row: any = { ...params.rowData };
            update_row[params.key] = change_val;
            update_data_arr.push(update_row);
            update_manager_by_ajax({
              data_arr: update_data_arr,
              select_seq: params.rowData.row_pri_val,
            });
          }} />
      );
    }

    return render_val;
  };

  return (
    <div>
      <div style={{ minWidth: "500px" }}>
        <SearchArea
          listOpt={listOpt}
          list={list}
          goDelete={goDelete}
          open_find_manager_popup={open_find_manager_popup}
        ></SearchArea>
        <div className="mt-1">
          <ListComponent
            ref={ListComponentRef}
            xColumnArr={{ ...xColumnArr }}
            gridOpt={{
              fix_left_num: xColumnArr.list_opt_arr.fix_left_num,
              is_add_idx_num: false,
              is_add_checkbox: true,
              td_align: "center",
              height: "auto",
              is_fix_width: true,
              rowMultiSelectWithClick: false,
              onGridReady: () => {

              },

              is_all_select_row_key: true,
              rowOnClick: rowOnClick,
              customCellRenderer: customCellRenderer,
              class_name_json: {
                table_div: "basic_list_div",
                td_div: "row-col-div",
                input_check: "chk_row",
                row_input: "row-input",
                data_row_tr: "data_row_tr",
                active_row: "active",
                empty_con_div: "list_empty_content_div",
              },
            }}
          ></ListComponent>
        </div>
      </div>
      {popupData.isOpen &&
        <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
          width={popupData.width} height={popupData.height} >

          {popupData.sort === "find_main_user" &&
            <FindMainUserPopup
              listOpt={popupData.listOpt}
              callBackData={callback_find_manager_data}
              refreshData={(inData: any) => { list({ now_page: 1 }); }}
              closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></FindMainUserPopup>
          }
        </LayerPopup>
      }
    </div>
  );
};
export default ShopManagerListArea;